import { useForm } from '@inertiajs/inertia-react';
import usePageProps from 'app/components/hooks/usePageProps';
import Layout from 'app/components/Layouts/Layout'
import { UserType } from 'app/components/Types/UserType';
import { ChangeImage } from 'app/fragments/Forms/ChangeImage';
import Form from 'app/fragments/Forms/Form'
import PasswordField from 'app/fragments/Forms/PasswordField';
import Submit from 'app/fragments/Forms/Submit';
import TextField from 'app/fragments/Forms/TextField';
import React from 'react'
import route from 'ziggy-js';

interface Props {
    user_detail: UserType
 }

function Detail(props: Props) {
    const { user_detail: user } = props

    // const { user_detail } = usePageProps<{ user: UserType }>();

    const form = useForm({
        name: user.name,
        UUID: user.UUID,
        email: user.email,
    });
    const { data, post } = form;

    const submit = (e) => {
        e.preventDefault();
        post(route('user.update', {user: user.UUID}));
    }

    return (
        <Layout heading='Profile'>
            <div className='w-full flex  flex-col '>
                <h2 className="text-24 font-bold my-40px">Ahoj {user.name}</h2>
                <div className='flex justify-center'>
                    <div className='p-20px  relative bg-gray rounded-default w-1/2  mob:w-full'>
                        <Form form={form} onSubmit={submit}>
                            <div className='flex gap-20px w-full'>
                                <div className='w-3/5 grow'>
                                    <ChangeImage name="thumbnail" label="Avatar" image={user.thumbnail} height="grow" />
                                </div>
                                <div className='w-full'>
                                    <TextField name="UUID" label="UUID" readOnly className='pointer-events-none' />
                                    <TextField name="name" label="Name" />
                                </div>
                            </div>

                            <TextField name="email" label="Email" />
                            <PasswordField name="current_password" label="Current password" />
                            <PasswordField name="password" label="New password" />
                            <PasswordField name="password_confirmation" label="Password confirmation" />
                            <Submit className='w-full' value="Save" />
                        </Form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Detail
